import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './assets/styles/main.css'
import { initAnalytics, trackPageView } from './utils/analytics'
import { registerAppServiceWorker } from './utils/pushNotifications'
import { loadBrand } from './services/brand'

Vue.config.productionTip = false

initAnalytics()
registerAppServiceWorker().catch(() => undefined)

router.afterEach((to) => {
  trackPageView(to)
})

// L'identité de l'instance est chargée avant le montage pour éviter un
// flash "Educ360" sur les instances white-label
loadBrand().finally(() => {
  new Vue({
    router,
    store,
    render: h => h(App),
  }).$mount('#app')
})
